$(document).ready(function() {
	if(!document.querySelector('.C0068')) return false;

	
	var componentCarouselSimple = {
		$el : null,
		init : function() {
			this.$el = $('.C0068');
			this.$el.find('.carousel-wrap-box').each(function(){
				/* LGEGMC-324 20200715 modify */
				var $this = $(this);
				var $carouselBox = $this.find('.carousel-wrap .carousel-box');
				if($carouselBox.length) {
					componentCarouselSimple.runSlick($this);
					setTimeout( function() {
						$('.C0068').find('.carousel-wrap .slick-prev').attr('aria-label', 'Previous Arrow');
						$('.C0068').find('.carousel-wrap .slick-next').attr('aria-label', 'Next Arrow');
					},3000);
					$('.C0068 .slick-track li').attr({
						tabindex: "-1"
					});	//DC-717
					
					$carouselBox.each(function(){
						var $target = $(this).find('video:visible[autoplay][muted]');
						if ($target.length) {
							setTimeout(function(){
								var targetVideo = $target[0];
								(targetVideo.paused && targetVideo.muted) && targetVideo.play();
							},500);
						}
					});
				}
				/* //LGEGMC-324 20200715 modify */
			});
		},
		runSlick: function($obj) {
			var fontColor = 'black';
			if($obj.find('.carousel-wrap .carousel-box').eq(0).find('.text-area').hasClass('text-white')) {
				fontColor = 'white';
			}
			var $slick = $obj.find('.carousel-wrap').slick({
				infinite: false, //LGEGMO-5525
				listStyle: true, //LGEGMO-5525
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows : true,
				dots: false,
				//adaptiveHeight: true,
				lazyLoad: 'ondemand',
				//autoplay: true,
				//autoplaySpeed: 10000,
				prevArrow: carouselOptions.bigAnglePrev, // common.js variable
				nextArrow: carouselOptions.bigAngleNext, // common.js variable
				appendDots:$obj.find('.slick-dot-wrap'),
				responsive: [
					{
					  breakpoint: 768,
					  settings: {
						dots: true
					 }
					}
				]
			});
			$obj.find('.carousel-wrap').addClass('slick-'+fontColor);
			$obj.find('.carousel-wrap').on('afterChange', function(event, slick, currentSlide){
				if($obj.find('.slick-current .text-area').hasClass('text-white')) {
					fontColor = 'white';
				} else {
					fontColor = 'black';
				}
				$obj.find('.carousel-wrap').removeClass('slick-white').removeClass('slick-black').addClass('slick-'+fontColor);
			});
		}
	};
	componentCarouselSimple.init();
	
});